$(document).ready(function () {
    // helper function
    function manageMobileSliders(...sliders) {
        sliders.forEach(initFn => {
            if (window.innerWidth <= 991) {
                initFn();
            }
            window.addEventListener('resize', function () {
                if (window.innerWidth <= 991) {
                    initFn();
                } else {
                    initFn(true);
                }
            });
        });
    }
    function hideMobileSliders(...sliders) {
        sliders.forEach(initFn => {
            if (window.innerWidth > 991) {
                initFn();
            }
            window.addEventListener('resize', function () {
                if (window.innerWidth > 991) {
                    initFn();
                } else {
                    initFn(true);
                }
            });
        });
    }



    $(document).on("click", function (event) {
        var $trigger = $(".header__icon--cart, .cart-drawer");
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
            $('.drawer').removeClass('active');
            $('.header__icon--cart').removeClass('cart-open');
            $('body').removeClass('overflow-hidden');
        }
    });

    $('.js-menu-btn').click(function () {
        $(this).toggleClass('open');
        $('body').toggleClass('open-menu');
        $('.drawer').removeClass('active');
        $('.header__icon--cart').removeClass('cart-open');
        $('body').removeClass('overflow-hidden');
    });
    $(document).on("click", function (event) {
        var $trigger = $(".hamburge-icon, .cwr-nav .innerWrap");
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
            $('.js-menu-btn').removeClass('open');
            $('body').removeClass('open-menu');
        }
    });

    // USPA Slider Start Here
    // function uspaSlider(destroy) {
    //     if (destroy) {
    //         if ($('.js-uspa-slider').hasClass('slick-initialized')) {
    //             $('.js-uspa-slider').slick('unslick');
    //         }
    //         return;
    //     }

    //     if ($('.js-uspa-slider').hasClass('slick-initialized')) return;

    $('.js-uspa-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        speed: 6000,
        variableWidth: false,
        arrows: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        swipeToSlide: false,
        draggable: false,
        prevArrow: `
            <button type="button" class="prev-arrow">
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 1C7 1 1.00001 5.4189 1 7C0.99999 8.5812 7 13 7 13" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        `,
        nextArrow: `
            <button type="button" class="next-arrow">
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1C1 1 6.99999 5.4189 7 7C7.00001 8.5812 1 13 1 13" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        `,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    variableWidth: true,
                    infinite: true,
                }
            }
            ,
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    variableWidth: true,
                    infinite: true,
                    swipeToSlide: true,
                    draggable: true,
                }
            }
        ]
    });
    // }
    // USPA Slider End Here

    // Seen Logo Slider Start Here

    if($('.js-seen-logo').length > 0){
        $('.js-seen-logo').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: false,
            dots: false,
            arrows: false,
            prevArrow: `
                <button type="button" class="prev-arrow">
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 1C7 1 1.00001 5.4189 1 7C0.99999 8.5812 7 13 7 13" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            `,
            nextArrow: `
                <button type="button" class="next-arrow">
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1C1 1 6.99999 5.4189 7 7C7.00001 8.5812 1 13 1 13" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            `,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                    }
                }
                ,
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3.5,
                    }
                }
            ]
        });
    }
    // Seen Logo Slider End Here



    // Customer Review Slider Start Here
    if($('.js-customer-review-slider').length > 0){
        $('.js-customer-review-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            infinite: false,
            arrows: true,
            prevArrow: $('.js-customer-review-prev-btn'),
            nextArrow: $('.js-customer-review-next-btn'),
            appendDots: $('.js-customer-review-dots'),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1.2,
                    }
                }
                ,
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1.1,
                    }
                }
            ]
        });
    }
    // Customer Review Slider End Here



    // Office Logo Slider Start Here
    if($('.js-office-logo-slider-one').length > 0){
        $('.js-office-logo-slider-one').slick({
            speed: 5800,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            slidesToShow: 6,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            dots: false,
            draggable: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            swipeToSlide: false,
            touchMove: false,
            centerMode: true,
            centerPadding: '0',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                    slidesToShow: 4,
                    infinite:true,
                    speed: 6800,
                    }
                }
                ,
                {
                    breakpoint: 767,
                    settings: {
                    slidesToShow: 3,
                    infinite:true,
                    speed: 7800,
                    }
                }
            ]
        });
    }
    if($('.js-office-logo-slider-two').length > 0){
        $('.js-office-logo-slider-two').slick({
            speed: 5800,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            slidesToShow: 6,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            dots: false,
            draggable: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            swipeToSlide: false,
            touchMove: false,
            centerMode: true,
            centerPadding: '0',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                    slidesToShow: 4,
                    infinite:true,
                    speed: 6800,
                    }
                }
                ,
                {
                    breakpoint: 767,
                    settings: {
                    slidesToShow: 3,
                    infinite:true,
                    speed: 7800,
                    }
                }
            ]
        });
    }
    if($('.js-office-logo-slider-three').length > 0){
        $('.js-office-logo-slider-three').slick({
            speed: 3500,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            draggable: false,
            pauseOnHover: false,
            swipeToSlide: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            arrows: false,
            dots: false,
            draggable: false,
            pauseOnHover: true,
            swipeToSlide: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                    slidesToShow: 4,
                    infinite:true,
                    }
                }
                ,
                {
                    breakpoint: 767,
                    settings: {
                    slidesToShow: 3,
                    infinite:true,
                    }
                }
            ]
        });
    }
    // Office Logo Slider End Here


    //  Review Slider Start Here
    if($('.js-review-slider').length > 0){
        $('.js-review-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: true,
            prevArrow: $('.js-review-prev-btn'),
            nextArrow: $('.js-review-next-btn'),
            appendDots: $('.js-review-dots'),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                }
                ,
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                }
                ,
                {
                    breakpoint: 641,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }
    // Review Slider End Here

    // Advisor Slider End Here
    function setEqualHeights(currentAdvisorSlides) {
        console.log("currentAdvisorSlides: ", currentAdvisorSlides);
    
        let maxFirstHeight = 0;
        let maxSecondHeight = 0;
        
        currentAdvisorSlides.each(function() {
            const divs = $(this).children('div');
            if (divs.length > 1) {
                const firstDivHeight = divs.eq(0).outerHeight();
                const secondDivHeight = divs.eq(1).outerHeight();
                
                if (firstDivHeight > maxFirstHeight) {
                    maxFirstHeight = firstDivHeight;
                }
                if (secondDivHeight > maxSecondHeight) {
                    maxSecondHeight = secondDivHeight;
                }
            }
        });
    
        currentAdvisorSlides.children('div:first-child').css('height', `${maxFirstHeight}px`);
        currentAdvisorSlides.children('div:nth-child(2)').css('height', `${maxSecondHeight}px`);
    }
    
    if($('.js-row-advisor').length > 0){
        $('.js-row-advisor').each(function() {
            const slider = $(this);
            slider.slick({
                rows: 2,
                dots: true,
                arrows: true,
                infinite: false,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 4,
                prevArrow: $('.js-advisor-prev-btn'),
                nextArrow: $('.js-advisor-next-btn'),
                appendDots: $('.js-advisor-dots'),
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    }
                ],
            });
    
            $(window).on('load', function() {
                setEqualHeights(slider.find('.slick-slide'));
            });
        });
    }
    // Advisor Slider End Here
    

    // Product Ingredients Slider Start Here
    function productIngredients(destroy) {
        if (destroy) {
            if ($('.js-product-ingredients-slider').hasClass('slick-initialized')) {
                $('.js-product-ingredients-slider').slick('unslick');
            }
            return;
        }

        if ($('.js-product-ingredients-slider').hasClass('slick-initialized')) return;

        $('.js-product-ingredients-slider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            autoplay: true,
            centerMode: true,
            autoplaySpeed: 3000,
            prevArrow: `
                <button type="button" class="prev-arrow">
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 1C7 1 1.00001 5.4189 1 7C0.99999 8.5812 7 13 7 13" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            `,
            nextArrow: `
                <button type="button" class="next-arrow">
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1C1 1 6.99999 5.4189 7 7C7.00001 8.5812 1 13 1 13" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            `,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        infinite: true,
                    }
                }
                ,
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        infinite: true,
                    }
                }
            ]
        });
    }
    // Product Ingredients Slider End Here


    // Partner Logo Slider Start Here
    if($('.js-partner-logo-slider').length > 0){
        $('.js-partner-logo-slider').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            speed: 3500,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: "linear",
            draggable: false,
            pauseOnHover: false,
            swipeToSlide: false,
            dots: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                }
                ,
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        });
    }
    // Partner Logo Slider End Here



    manageMobileSliders(productIngredients);

    $('body').on("click",".js-accordain-que",function(e){
        if($(this).hasClass('active')) {
            $('.js-accordain-answer').slideUp();
            $('.js-accordain-que').removeClass("active");
        } else {
            $('.js-accordain-answer').slideUp();
            $('.js-accordain-que').removeClass("active");
            $(this).next('.js-accordain-answer').slideDown();
            $(this).addClass('active');
        }
    });



    // Sticky Header

    function stickyItems(){
        if($('.sticky-bar').length > 0){
            let getAnnouncementHeight = $('.cwr-announcement-bar').outerHeight();
            console.log(getAnnouncementHeight);
            $('.cwr-header-sticky').css('top', getAnnouncementHeight);
        }
    }
    stickyItems();
    $(window).on('resize', function(){
        stickyItems();
    });
    // Tab Content 
    $('.js-cwr-tabs li').first().addClass('active');
    $('.js-tabs-content .cwr-accordion__item').first().fadeIn();
    $('.js-cwr-tabs li a').on('click', function(e)  {
        e.preventDefault();
        var currentAttrValue = $(this).attr('data-ref');
        // Show/Hide Tabs
        $('.js-tabs-content ' + currentAttrValue).fadeIn(400).siblings().hide();
        // Change/remove current tab to active
        $(this).parent('li').addClass('active').siblings().removeClass('active');
        e.preventDefault();
    });


    $('body').on('change', '.size-variant', function(){
        var class_name = `for_hide_${$(this).attr("id")}`;
        $(this).closest('product-form').find('.product__subscribe-row').hide();
        $(this).closest('product-form').find('.'+class_name).show();
       //$(this).closest('product-form').find('.'+class_name).find('.plan_id:last').attr("checked", true).trigger("change").click();
       if($('[data-radio-active]').length > 0){
       $('[data-radio-active]:visible').trigger('click');
        }else{
            $(this).closest('product-form').find('.'+class_name).find('.plan_id:last').attr("checked", true).trigger("change").click();
        }
    });

    $('body').on('change', '.product__subscribe-input',function(e){
      $(this).closest('product-form').find('.change_price').html($(this).attr("data-price"));
      $(this).closest('product-form').find('[name=id]').val($(this).attr("value"));
     
    });

    // setTimeout(function() {
    //     $('.product__variant-input--2').prop('checked', true).trigger('change');
    // }, 1000);
         setTimeout(function() {
            $('.size-variant:checked').prop('checked', true).trigger('change');
            // $('.product__subscribe-input:checked:visible').trigger('click');
            $('[data-radio-active]:visible:checked').trigger('change');
    }, 1000);
    

});